import { configureStore } from "@reduxjs/toolkit";
import lightToggle from "./toggle-item/lightToggle";

const store = configureStore({
    reducer:{
        light:lightToggle.reducer,
    }
})

export default store;